import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-0 ms-0 me-0 mb-5 border-bottom shadow-sm" }
const _hoisted_2 = { class: "col-12 col-md-4 m-auto text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-secondary mt-auto" }, " All images are by me! ", -1)
const _hoisted_4 = { class: "col-12 col-md-8 h-100" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.randomImage.description), 1),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        src: _ctx.randomImage.src,
        class: "img-fluid",
        alt: "Background Image"
      }, null, 8, _hoisted_5)
    ])
  ]))
}